import clsx from 'clsx'
import UiPill from 'components/Ui/UiPill'
import { useCrmLifecycleStatusOptions } from 'utils/crmLifecycleStatusUtils'
import { CrmLifecycleStatus } from 'types/enums/CrmLifecycleStatus'

const UiCrmLifecycleStatusPill = ({ status }: { status: CrmLifecycleStatus }) => {
    const options = useCrmLifecycleStatusOptions()
    const label =
        options.find((option) => option.value === status)?.label ||
        String(status)

    const color = (() => {
        switch (status) {
            case CrmLifecycleStatus.Database:
                return 'pill-tone-slate'
            case CrmLifecycleStatus.Pipeline:
                return 'pill-tone-blue'
            case CrmLifecycleStatus.ExistingCustomer:
                return 'pill-tone-green'
            case CrmLifecycleStatus.Rejection:
                return 'pill-tone-orange'
            case CrmLifecycleStatus.Archive:
                return 'pill-tone-gray'
            default:
                return 'pill-tone-slate'
        }
    })()

    return <UiPill className={clsx('UiCrmLifecycleStatusPill', color)}>{label}</UiPill>
}

export default UiCrmLifecycleStatusPill
